<div #tooltip class="tooltip">
  @if (items?.length) {
    <div class="top">
      @if (layerName) {
        <h3>{{ layerName }}</h3>
      }
      @for (i of items; track i) {
        <div>
          @if (i.category) {
            <p>
              <b>{{ i.category }}</b>
            </p>
          }
          <p>{{ i.text }}</p>
        </div>
      }
      <i></i>
    </div>
  }
</div>
